@if (active_device && is_admin) {
  <ts-admin-override-banner
    [admin_override]="devices_payload.include_admin_options"
    [prevent_default]="admin_cart_items"
    [disabled]="disable_admin_overide"
    (emit_cart_change)="confirmAdminToggleClearCart($event)"
    (emit_admin_override)="getAdminOverride($event)"
  />
}

@if (active_device) {
  <div class="container-md pb-4 pb-sm-0 p-md-0 pb-md-2 device-details">
    <div class="row g-4">
      <div class="col-12 col-lg-5">
        <ts-device-image-placeholder
          [device]="active_device"
          [product_category]="active_device.product_category"
        />
      </div>

      <div class="col-12 col-lg-7">
        <div class="row flex-column gap-2rem">
          <div class="col">
            <ts-device-description [device]="active_device" />
          </div>

          <div class="col">
            <ts-device-carrier
              [device_items]="device_record"
              [selected_carrier_id]="selected_carrier_id"
              [order_type_id]="devices_payload.orderTypeId"
              (selected_carrier)="selectCarrierClick($event)"
            />
          </div>

          <!-- Color Section -->
          @if (normalized_device_list_by_color.length) {
            <div class="col">
              <h4 class="mb-3 display-4">{{ 'color' | translate }}</h4>
              <hr class="mb-3" />
              <div class="row row-cols-7 row-cols-md-12 g-3">
                @for (device of normalized_device_list_by_color; track device) {
                  <div class="col col-auto">
                    <div
                      as-button
                      class="device-color"
                      [class.device-color__active]="device.id === selected_color_device_id"
                      [class.elevate]="device.id !== selected_color_device_id"
                      [style.background-color]="device.color | lowercase"
                      [attr.aria-label]="device.original_color"
                      (click)="selectColorClick(device)"
                    ></div>
                  </div>
                }
              </div>
              @if (active_device.original_color || active_device.color) {
                <h5 class="mt-3 mb-0">
                  {{ active_device.original_color || active_device.color }}
                </h5>
              }
            </div>
          }

          <!-- Storage Capacity -->
          @if (storage_list.length) {
            <div class="col">
              <h4 class="mb-3 display-4">
                {{ 'storage_capacity' | translate }}
              </h4>
              <hr class="mb-3" />
              <div class="row row-cols-2 row-cols-md-4 g-3">
                @for (device of storage_list; track device) {
                  <div class="col">
                    <div
                      as-button
                      class="card overflow-auto h-100"
                      [ngClass]="{ 'p-3': device.admin }"
                      [class.active-card]="getActiveStorage(device)"
                      [class.elevate]="
                        device.size !== selected_storage_size ||
                        device.id != selected_storage_device_id
                      "
                      [attr.aria-label]="device.size"
                      (click)="selectStorageClick(device)"
                    >
                      <div
                        class="card-body flex-column d-flex align-items-center justify-content-center"
                      >
                        <h5 class="mb-1">{{ device.size }}</h5>
                        <small class="text-secondary fw-normal">
                          {{ device.price.onetime.cost_to_currency }}
                        </small>
                        @if (!!device.price?.monthly?.cost_to_currency) {
                          <span class="text-secondary text-size-sm fw-normal">
                            {{ 'plus' | translate }}
                            {{ appendMonthlyLabel(device.price.monthly.cost_to_currency) }}
                          </span>
                        }
                      </div>

                      <ng-container
                        *ngTemplateOutlet="adminBadge; context: { admin: device.admin }"
                      />
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          <!-- Name Overrides -->
          @if (name_override_list.length > 0 && show_options) {
            <div class="col">
              <h4 class="mb-3 display-4">
                {{ 'options' | translate }}
                <span class="text-secondary fs-6"> ({{ 'choose_one' | translate }}) </span>
              </h4>
              <hr class="mb-3" />
              <div class="row row-cols-1 g-3">
                @for (device of name_override_list; track device) {
                  <div class="col">
                    <div
                      as-button
                      class="card"
                      [ngClass]="{ 'p-2': device.admin }"
                      [class.active-card]="device.id === selected_name_override_id"
                      [class.elevate]="device.id !== selected_name_override_id"
                      [attr.aria-label]="device.name_override || device.name"
                      (click)="selectNameOverrideClick(device)"
                    >
                      <div class="card-body">
                        <h5 class="mb-1">{{ device.name_override || device.name }}</h5>
                      </div>

                      <ng-container
                        *ngTemplateOutlet="adminBadge; context: { admin: device.admin }"
                      />
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (device_record?.length) {
  <ts-price-summary
    [id]="device_plan.deviceId"
    [navigate_page]="page_to_navigate"
    [button_status]="disable_continue_btn || content_loading"
    [reset_cart]="true"
    [shopping_cart]="shopping_cart"
    [shopping_items_price]="shopping_items_price"
    [is_display_one_time_cost]="is_display_one_time_cost"
    [is_display_recurring_cost]="is_display_recurring_cost"
    [refresh_summary]="refresh_summary.asObservable()"
    (updateCostSummary)="getShoppingCartData($event)"
  />
}

<ng-template #adminBadge let-admin="admin">
  @if (admin) {
    <ts-admin-override-badge class="position-absolute bottom-0 end-0 border-top-left-radius" />
  }
</ng-template>
